import { success, request, failure, invalid } from "./helpers";
import {
  GET_CAMPAIGNS_TABLES,
  GET_CAMPAIGNS_CSV_DATA,
  GET_EMAIL_CAMPAIGN_LIST,
  GET_SOCIAL_CAMPAIGN_LIST,
  GET_DISPLAY_CAMPAIGN_LIST,
  GET_CAMPAIGN_GROUP_AGGREGATED,
  GET_CAMPAIGN_AGGREGATED_BY_CHANNEL,
  GET_CAMPAIGN_EMAIL_AGGREGATED,
  GET_CAMPAIGN_SOCIAL_AGGREGATED,
  GET_CAMPAIGN_DISPLAY_AGGREGATED,
  GET_CAMPAIGN_EMAIL_STATS_AGGREGATED,
  GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED,
  GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED,
  GET_CAMPAIGN_TOP_LINK_STATS,
  GET_CAMPAIGN_TOP_LOCATION_STATS,
  SET_REPORT_DATE_RANGE,
  SAVE_CAMPAIGN_GROUP,
  GET_CAMPAIGN_DETAIL,
  CLEAR_CAMPAIGN_DETAIL,
  CLEAR_CMAPAIGNS_CSV_DATA,
  SET_CHANNEL_CAMPAIGN_ID,
  SET_CAMPAIGN_FILTER_START_DATE,
  SET_CAMPAIGN_FILTER_END_DATE,
  SET_CAMPAIGN_FILTER_VALUE,
  SET_SEGMENT_ID,
  CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE,
} from "../actions/Campaign";

export const initialState = {
  tables: {},
};
const campaigns = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_CAMPAIGN_DETAIL:
      return {
        ...state,
        campaignDetail: undefined,
        campaignDataOnLoading: false,
        campaignDataLoadErrorMessage: undefined,
        channelCampaigns: undefined,
        savingCampaignErrorMessage: undefined,
      };
    case CLEAR_CMAPAIGNS_CSV_DATA:
      return {
        ...state,
        csvData: undefined,
      };
    case SET_CAMPAIGN_FILTER_START_DATE:
      return {
        ...state,
        campaignFilterStartDate: action.value,
      };
    case SET_CAMPAIGN_FILTER_END_DATE:
      return {
        ...state,
        campaignFilterEndDate: action.value,
      };
    case SET_CAMPAIGN_FILTER_VALUE:
      return {
        ...state,
        campaignFilterValue: action.value,
      };
    case request(GET_CAMPAIGNS_TABLES):
      return {
        ...state,
        tables: [],
        campaignDataOnLoading: true,
        campaignDataLoadErrorMessage: undefined,
        savingCampaignErrorMessage: undefined,
      };
    case success(GET_CAMPAIGNS_CSV_DATA):
      return {
        ...state,
        csvData: action.payload,
      };
    case success(GET_CAMPAIGNS_TABLES):
      return {
        ...state,
        tables: action.payload,
        campaignDataOnLoading: false,
        campaignDataLoadErrorMessage: undefined,
      };
    case failure(GET_CAMPAIGNS_TABLES):
    case invalid(GET_CAMPAIGNS_TABLES):
      return {
        ...state,
        tables: [],
        campaignDataOnLoading: false,
        campaignDataLoadErrorMessage: action.payload.message,
      };

    case request(GET_EMAIL_CAMPAIGN_LIST):
      return {
        ...state,
        emailChannelCampaigns: undefined,
      };
    case success(GET_EMAIL_CAMPAIGN_LIST):
      return {
        ...state,
        emailChannelCampaigns: action.payload,
      };
    case request(GET_SOCIAL_CAMPAIGN_LIST):
      return {
        ...state,
        socialChannelCampaigns: undefined,
      };
    case success(GET_SOCIAL_CAMPAIGN_LIST):
      return {
        ...state,
        socialChannelCampaigns: action.payload,
      };
    case request(GET_DISPLAY_CAMPAIGN_LIST):
      return {
        ...state,
        displayChannelCampaigns: undefined,
      };
    case success(GET_DISPLAY_CAMPAIGN_LIST):
      return {
        ...state,
        displayChannelCampaigns: action.payload,
      };
    case request(SAVE_CAMPAIGN_GROUP):
      return {
        ...state,
        onSavingCampaign: true,
        savingCampaignErrorMessage: undefined,
      };
    case success(SAVE_CAMPAIGN_GROUP):
      return {
        ...state,
        onSavingCampaign: false,
        savingCampaignErrorMessage: undefined,
      };
    case failure(SAVE_CAMPAIGN_GROUP):
    case invalid(SAVE_CAMPAIGN_GROUP):
      return {
        ...state,
        onSavingCampaign: false,
        savingCampaignErrorMessage: action.payload.message,
      };
    case success(GET_CAMPAIGN_DETAIL):
      return {
        ...state,
        campaignDetail: action.payload,
      };
    case failure(GET_CAMPAIGN_TOP_LINK_STATS):
    case invalid(GET_CAMPAIGN_TOP_LINK_STATS):
      return {
        ...state,
        loadingTopLinkStats: undefined,
        topLinkStats: undefined,
      };
    case success(GET_CAMPAIGN_TOP_LINK_STATS):
      return {
        ...state,
        loadingTopLinkStats: false,
        topLinkStats: action.payload,
      };
    case request(GET_CAMPAIGN_TOP_LINK_STATS):
      return {
        ...state,
        loadingTopLinkStats: true,
        topLinkStats: undefined,
      };
    case SET_REPORT_DATE_RANGE:
      return {
        ...state,
        reportDateRange: action.value,
      };
    case SET_CHANNEL_CAMPAIGN_ID:
      return {
        ...state,
        channelCampaignId: action.value,
      };
    case SET_SEGMENT_ID:
      return {
        ...state,
        segmentId: action.value,
      };
    case success(GET_CAMPAIGN_GROUP_AGGREGATED):
      return {
        ...state,
        campaignAggregatedReport: action.payload,
      };
    case success(GET_CAMPAIGN_AGGREGATED_BY_CHANNEL):
      return {
        ...state,
        campaignChannelAggregatedReport: action.payload,
      };
    case request(GET_CAMPAIGN_EMAIL_AGGREGATED):
      return {
        ...state,
        emailAggregatedReport: undefined,
      };
    case request(GET_CAMPAIGN_EMAIL_STATS_AGGREGATED):
      return {
        ...state,
        emailAggregatedStats: undefined,
      };
    case success(GET_CAMPAIGN_EMAIL_AGGREGATED):
      return {
        ...state,
        emailAggregatedReport: action.payload,
      };
    case success(GET_CAMPAIGN_EMAIL_STATS_AGGREGATED):
      return {
        ...state,
        emailAggregatedStats: action.payload,
      };
    case request(GET_CAMPAIGN_SOCIAL_AGGREGATED):
      return {
        ...state,
        socialAggregatedReport: undefined,
      };
    case request(GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED):
      return {
        ...state,
        socialAggregatedStats: undefined,
      };
    case request(GET_CAMPAIGN_DISPLAY_AGGREGATED):
      return {
        ...state,
        displayAggregatedReport: undefined,
      };
    case request(GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED):
      return {
        ...state,
        displayAggregatedStats: undefined,
      };
    case success(GET_CAMPAIGN_SOCIAL_AGGREGATED):
      return {
        ...state,
        socialAggregatedReport: action.payload,
      };
    case success(GET_CAMPAIGN_SOCIAL_STATS_AGGREGATED):
      return {
        ...state,
        socialAggregatedStats: action.payload,
      };
    case success(GET_CAMPAIGN_DISPLAY_AGGREGATED):
      return {
        ...state,
        displayAggregatedReport: action.payload,
      };
    case success(GET_CAMPAIGN_DISPLAY_STATS_AGGREGATED):
      return {
        ...state,
        displayAggregatedStats: action.payload,
      };
    case request(GET_CAMPAIGN_TOP_LOCATION_STATS):
    case failure(GET_CAMPAIGN_TOP_LOCATION_STATS):
    case invalid(GET_CAMPAIGN_TOP_LOCATION_STATS):
      return {
        ...state,
        topLocationOpensStats: undefined,
      };
    case success(GET_CAMPAIGN_TOP_LOCATION_STATS):
      return {
        ...state,
        topLocationOpensStats: action.payload,
      };
    case CLEAR_SAVE_CAMPAIGN_ERROR_MESSAGE:
      return {
        ...state,
        savingCampaignErrorMessage: undefined,
      };
    default:
      return state;
  }
};

export default {
  campaigns,
};



// WEBPACK FOOTER //
// ./src/reducers/campaigns.js